import React from 'react';
import { buildWhatsAppBookingMessage, buildWhatsAppBookingUrl } from '../../utils/whatsapp';
import { trackEvent } from '../../services/analytics';

interface WhatsAppBookingLinkProps {
  className?: string;
  children?: React.ReactNode;
  dropoff?: string | null;
  dropoffLat?: number | null;
  dropoffLng?: number | null;
  pickup?: string | null;
  pickupLat?: number | null;
  pickupLng?: number | null;
  placement: string;
}

const WhatsAppBookingLink: React.FC<WhatsAppBookingLinkProps> = ({
  className = 'sw-whatsapp-link',
  children = 'Book on WhatsApp',
  dropoff,
  dropoffLat,
  dropoffLng,
  pickup,
  pickupLat,
  pickupLng,
  placement,
}) => {
  const message = buildWhatsAppBookingMessage({ pickup, pickupLat, pickupLng, dropoff, dropoffLat, dropoffLng });
  const href = buildWhatsAppBookingUrl(message);

  if (!href) return null;

  return (
    <a
      className={className}
      href={href}
      onClick={() => trackEvent('whatsapp_booking_clicked', { placement })}
      rel="noopener noreferrer"
      target="_blank"
    >
      <span className="sw-whatsapp-glyph" aria-hidden="true">WA</span>
      <span>{children}</span>
    </a>
  );
};

export default WhatsAppBookingLink;
